/** Previous calendar month in local time, as YYYY-MM-DD for `<input type="date" />`. */
export function previousMonthRangeISO(now = new Date()) {
  const y = now.getFullYear();
  const m = now.getMonth();
  const end = new Date(y, m, 0);
  const start = new Date(end.getFullYear(), end.getMonth(), 1);
  const fmt = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  return { start: fmt(start), end: fmt(end) };
}
